export default __webpack_public_path__ + "images/0x82af49447d8a07e3bd95bd0d56f35241523fbab1.png";